export default {
    title: 'Данный раздел пока недоступен на мобильных устройствах',
    description: 'Используйте компьютер для доступа к полному функционалу программы',
};
